import type { IconProps } from './IconProps';

export const DownloadIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25977 1.25C8.67398 1.25 9.00977 1.58579 9.00977 2V9.52267L11.7294 6.803C12.0223 6.51011 12.4972 6.51011 12.7901 6.803C13.083 7.0959 13.083 7.57077 12.7901 7.86366L8.7901 11.8637C8.4972 12.1566 8.02233 12.1566 7.72944 11.8637L3.72944 7.86366C3.43654 7.57077 3.43654 7.0959 3.72944 6.803C4.02233 6.51011 4.4972 6.51011 4.7901 6.803L7.50977 9.52267V2C7.50977 1.58579 7.84555 1.25 8.25977 1.25ZM1.50977 14C1.50977 13.5858 1.84555 13.25 2.25977 13.25H14.2598C14.674 13.25 15.0098 13.5858 15.0098 14C15.0098 14.4142 14.674 14.75 14.2598 14.75H2.25977C1.84555 14.75 1.50977 14.4142 1.50977 14Z"
      fill="currentColor"
    />
  </svg>
);
